import axios from 'axios'

export default {
    namespaced: true,
    state: {
        restaurants: []
    },
    mutations: {
        FETCH_RESTAURANTS(state, restaurants) {
            state.restaurants = restaurants.map(item => {
                if (item.options === null) {
                    item.options = []
                }
                return item
            })
        },
        ADD_RESTAURANTS(state, restaurant) {
            restaurant.options = restaurant.options === null ? [] : restaurant.options
            state.restaurants.push(restaurant)
        },
        EDIT_RESTAURANTS(state, restaurant) {
            const index = state.restaurants.findIndex(
                item => item.id === restaurant.id
            )
            if (index !== -1) {
                restaurant.options = restaurant.options === null ? [] : restaurant.options
                Object.assign(state.restaurants[index], restaurant)
            }
        },
        DEL_RESTAURANTS(state, restaurant) {
            const index = state.restaurants.findIndex(
                item => item.id === restaurant.id
            )
            if (index !== -1) {
                state.restaurants.splice(index, 1)
            }
        }
    },
    actions: {
        selectionList({dispatch}) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/restaurant-manager/restaurants/selection-list'
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        fetch({commit, dispatch, state}, isPreload = true) {
            return new Promise((resolve, reject) => {
                if (state.restaurants.length) {
                    resolve()
                } else {
                    if (isPreload) {
                        commit('TOGGLE_PRELOADER', true, {root: true})
                    }
                    axios.get(
                        '/api/restaurant-manager/restaurants/list',
                    ).finally(() => {
                        if (isPreload) {
                            commit('TOGGLE_PRELOADER', false, {root: true})
                        }
                    }).then(({data}) => {
                        commit('FETCH_RESTAURANTS', data.data)
                        resolve()
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        add({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/restaurant-manager/restaurants/add',
                    prepareData(payload)
                ).then(({data}) => {
                    commit('ADD_RESTAURANTS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/restaurant-manager/restaurants/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    commit('EDIT_RESTAURANTS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/restaurant-manager/restaurants/dell/' + itemId
                ).then(({data}) => {
                    commit('DEL_RESTAURANTS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('working_mode', data.working_mode)
    fd.append('address', data.address)
    data.options.forEach((element, index) => {
        fd.append('options['+index+'][icon]', element.icon)
        fd.append('options['+index+'][title]', element.title)
    })
    fd.append('category_id', data.category_id)
    fd.append(
        'phone',
        data.phone.replace(/[^0-9]/g,"")
    )
    if (data.intro) {
        fd.append('intro', data.intro)
    }
    if (data.menu_link) {
        fd.append('menu_link', data.menu_link)
    }
    if (data.bar_link) {
        fd.append('bar_link', data.bar_link)
    }

    return fd
}
